import { ThemeProvider as NextThemesProvider } from "next-themes";

/**
 * Doit rester aligné avec le script anti-flash de `index.html` : c'est lui qui
 * pose la classe `dark` avant le premier paint, en relisant cette même clé.
 */
export const THEME_STORAGE_KEY = "yeati-theme";

export const THEMES = ["light", "dark", "system"] as const;

export type Theme = (typeof THEMES)[number];

type ThemeProviderProps = { children: React.ReactNode };

/**
 * Le défaut est `light` et non `system` : la console n'a jamais eu de mode
 * sombre, on ne bascule donc personne sans action explicite.
 */
export const ThemeProvider = ({ children }: ThemeProviderProps) => (
  <NextThemesProvider
    attribute="class"
    defaultTheme="light"
    enableSystem
    storageKey={THEME_STORAGE_KEY}
    disableTransitionOnChange
  >
    {children}
  </NextThemesProvider>
);

export default ThemeProvider;
